import React from "react";
import { useSelector } from "react-redux";

import { getConservatoryAlias } from "../../helpers/conservatories";
import { getSeasonName } from "../../helpers/seasonName";

import {
  Container,
  UterumImage,
  UterumImageContainer,
  IntroText,
} from "./style";

export const PrintFrontPage = () => {
  const init = useSelector((state) => state.init);
  const Uterum = useSelector((state) => state.Uterum);
  const Result = useSelector((state) => state.Result);

  const { assetBaseUrl, alias } = init;

  return (
    <Container>
      <h2>{getConservatoryAlias(Uterum.FrameType, alias)}</h2>
      <hr />
      <h4>
        {Result.SquareMeterStomme} m<sup>2</sup> - {Uterum.FrameWidth} x{" "}
        {Uterum.FrameDepth} mm - {getSeasonName(alias, Uterum.Season)}
      </h4>
      <hr />
      <UterumImageContainer data-testid="uterumsImage">
        {Result.ImagesLeft.Images.map((image, index) => (
          <UterumImage
            key={index}
            src={`${assetBaseUrl}/store/uterumsguide2016/${image.ImageFolder}/ANGLE_LEFT/${image.Area}/${image.Img}.png`}
          />
        ))}
      </UterumImageContainer>
      <IntroText>
        <h3>{alias.bfcWelcome}</h3>
        <p>{alias.bfcWhatYouBuild}</p>
        <p>{alias.bfcPrintIntro}</p>
      </IntroText>
    </Container>
  );
};
